import { IPBanFormDataInterface } from '@/services/IPSet/Interfaces'
import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class IPBanFormData implements IPBanFormDataInterface {
  public ip: string = ''
  public timeout: number
  public comment: string = ''
  public packets: number = 0
  public bytes: number = 0
  public skbMark: string = ''
  public skbPrio: string = ''
  public skbQueue: number = 0

  public rules: { [key: string]: FormValidationFunction[] } = {
    ip: [
      (v: string) => !!v || 'IP is missing',
      (v: string) => !!v.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(\/\d{1,2})?$/g) || 'Invalid IP address or mask',
      (v: string) => ((v.search('/') !== -1 ? v.substring(0, v.search('/')) : v)
                        .split('.')
                        .map((piece) => Number(piece) >= 0 && Number(piece) <= 255)
                        .indexOf(false) === -1 || 'Invalid IP Address'),
      (v: string) => (
        v.search('/') !== -1 ? (
          Number(v.split('/')[1]) >= 8 && Number(v.split('/')[1]) <= 32 ? true : 'Invalid Mask'
        ) : true
      ),
    ],
    timeout: [
      // (v: number) => v !== undefined || 'Timeout is required',
      (v: number) => v >= 0 || 'Timeout has to have a positive value',
    ],
    packets: [
      // (v: number) => v !== undefined || 'Packets is required',
      (v: number) => v >= 0 || 'Packets has to have a positive value',
    ],
    bytes: [
      // (v: number) => v !== undefined || 'Packets is required',
      (v: number) => v >= 0 || 'Packets has to have a positive value',
    ],
  }
}
